@include host-component-properties;

:host {
  --paf-timetable-form-margin-block-end-large: 80;
  --paf-timetable-form-margin-block-end-small: 56;
  --paf-timetable-summary-margin-block-end-large: 40;
  --paf-timetable-summary-margin-block-end-small: 23;
  --paf-timetable-expand-transition-duration: 370ms;
  --paf-timetable-button-margin: 15;
  --paf-timetable-leg-border-style: #{px-to-rem(var(--paf-global-border-width-1x))} solid var(--paf-global-post-brand-secondary);
  --paf-timetable-list-vertical-space: 8;

  @include forced-colors {
    --paf-timetable-list-vertical-space: 16;
  }
}

:host([data-has-custom-focus]):before {
  display: none !important;
}

.timetable {
  .summary {
    margin-block-start: px-to-rem(var(--paf-timetable-form-margin-block-end-small));
    margin-block-end: px-to-rem(var(--paf-timetable-summary-margin-block-end-small));

    @include mq($from: medium) {
      margin-block-start: px-to-rem(var(--paf-timetable-form-margin-block-end-large));
      margin-block-end: px-to-rem(var(--paf-timetable-summary-margin-block-end-large));
    }
  }

  paf-no-results {
    margin-block-start: px-to-rem(var(--paf-timetable-form-margin-block-end-small));

    @include mq($from: medium) {
      margin-block-start: px-to-rem(var(--paf-timetable-form-margin-block-end-large));
    }
  }

  .result-list {
    .day-results {
      padding: 0;
      margin: 0;
      flex: 0 0 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      row-gap: px-to-rem(var(--paf-timetable-list-vertical-space));
    }

    .day-results:last-of-type:has(paf-result-timetable-row:only-of-type) {
      margin-block-start: px-to-rem(var(--paf-timetable-list-vertical-space));
    }

    .level-2 {
      display: grid;
      grid-template-rows: 0fr;
      opacity: 0;
      overflow: hidden;
      transition-duration: var(--paf-timetable-expand-transition-duration);
      will-change: opacity, grid-template-rows;
      transition-property: opacity, grid-template-rows;
      transition-timing-function: ease-in-out;
      position: relative;

      &.is-expanded {
        grid-template-rows: 1fr;
        opacity: 1;
        z-index: 3;
      }

      .legs-wrapper {
        overflow: hidden;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        paf-result-timetable-leg,
        paf-result-alert,
        paf-result-footpath,
        .legend,
        .notification {
          flex: 0 0 100%;
        }

        > *:not(paf-button) {
          border-top: var(--paf-timetable-leg-border-style);
        }
      }

      .result-timetable-row__link-mobile {
        display: none;

        @include mq($to: large) {
          display: inline-block;
          margin: px-to-rem(var(--paf-timetable-button-margin));
          z-index: 4;
        }
      }
    }
  }
}
